/**
 * Download URLs for native app installers.
 * Desktop builds are hosted on S3+CloudFront (downloads.panluma.ai).
 * Mobile store links are placeholders until store submissions are accepted.
 */
export const DOWNLOAD_URLS = {
  mac: 'https://downloads.panluma.ai/desktop/PanLuma.dmg',
  windows: 'https://downloads.panluma.ai/desktop/PanLuma.msi',
  android: '#', // Placeholder - not yet on Google Play
  ios: '#', // Placeholder - not yet on App Store
};
